interface Option {
  value: string;
  label: string;
  sublabel?: string;
}

interface Props {
  label: string;
  options: Option[];
  selected: string[];
  onChange: (selected: string[]) => void;
  emptyLabel?: string;
}

/** A scrollable checkbox list for picking a set of ids (e.g. services in a package). */
export function CheckboxMultiSelect({ label, options, selected, onChange, emptyLabel }: Props) {
  const toggle = (value: string) => {
    onChange(selected.includes(value) ? selected.filter((v) => v !== value) : [...selected, value]);
  };

  return (
    <div>
      <label className="block text-sm text-foreground mb-1">{label}</label>
      {options.length === 0 ? (
        <p className="text-sm text-muted-foreground py-2">{emptyLabel ?? 'Nothing to select.'}</p>
      ) : (
        <div className="max-h-48 overflow-y-auto rounded-[10px] border border-[#D9D9D9] bg-muted divide-y divide-border">
          {options.map((opt) => (
            <label key={opt.value} className="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-card">
              <input
                type="checkbox"
                checked={selected.includes(opt.value)}
                onChange={() => toggle(opt.value)}
                className="h-4 w-4 accent-[#28282A]"
              />
              <span className="text-sm text-foreground">{opt.label}</span>
              {opt.sublabel && <span className="text-xs text-muted-foreground ml-auto">{opt.sublabel}</span>}
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
